module.exports = __webpack_public_path__ + "d7aea0fba46b6d8548ef6d7d272239b0.png";